import { Margins } from 'pdfmake/interfaces';

export const PdfSettings = {
  pageMargins: [40, 60, 40, 60] as Margins,
  defaultStyle: {
    fontSize: 10,
  },
  styles: {
    header: {
      fontSize: 18,
      bold: true,
    },
    subheader: {
      fontSize: 15,
      bold: true,
      lineHeight: 2,
    },
    subheader2: {
      fontSize: 15,
      bold: true,
      lineHeight: 1,
    },
    sectionheader: {
      bold: true,
      lineHeight: 2,
    },
    tableHeader: {
      bold: true,
      lineHeight: 1,
    },
    textLine: {
      bold: false,
      lineHeight: 0.6,
    },
    tableCell: {
      margin: [0, 0, 10, 0] as Margins,
    },
  },
};
